import React from "react";
import { motion } from "framer-motion";
import "../Styles/Testimonials.css";
import { FaQuoteRight, FaStar } from "react-icons/fa";
import IntlMessages from "../../../intl/IntlMessages";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      content: <IntlMessages id="testimonials.excellentService" />,
      author: "Mr Etot",
      role: <IntlMessages id="testimonials.director" />,
      company: "Paiecash",
      rating: 5,
    },
    {
      id: 2,
      content:
      <IntlMessages id="testimonials.realEstateNeeds" />,
      author: "Mr Samir Come",
      role: <IntlMessages id="testimonials.manager" />,
      company: "META",
      rating: 5,
    },
    {
      id: 3,
      content:
      <IntlMessages id="testimonials.highEndService" />,
      author: "Mr Diop",
      role: <IntlMessages id="testimonials.manager" />,
      company: "HTELICAM",
      rating: 5,
    },
  ];

  return (
    <section className="testimonials-section">
      <div className="testimonials-bg-pattern" />
      <div className="testimonials-container">
        <motion.div
          className="testimonials-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2>
            <IntlMessages id="testimonials.clientFeedback" />
          </h2>
          <p>
            <IntlMessages id="testimonials.trustExperience" />
          </p>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              className="testimonial-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="quote-icon">
                <FaQuoteRight />
              </div>
              <div className="rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
              <p className="testimonial-content">{testimonial.content}</p>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>{testimonial.author}</h4>
                  <p>{testimonial.role}</p>
                  <span>{testimonial.company}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
